import { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { api } from '../api/client';

export default function ResetPasswordModal({ user, onClose, onDone }) {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const submit = async () => {
    setErr('');
    if (password.length < 6) { setErr('Password must be at least 6 characters'); return; }
    setBusy(true);
    try {
      await api.post(`/admin/users/${user.user_id}/password`, { password });
      onDone(`Password reset for ${user.name || user.email}. Share the new password with them manually.`);
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header closeButton><Modal.Title>Reset Password — {user.name || user.email}</Modal.Title></Modal.Header>
      <Modal.Body>
        {err && <Alert variant="danger">{err}</Alert>}
        <Alert variant="warning" className="small py-2 mb-3">
          Sets a new password for <strong>{user.email}</strong>. Share it with them through a trusted channel —
          it is not emailed automatically.
        </Alert>
        <Form.Group>
          <Form.Label>New password</Form.Label>
          <Form.Control
            type="text"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="min 6 chars"
            autoFocus
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button onClick={submit} disabled={busy || password.length < 6}>{busy ? 'Resetting…' : 'Reset password'}</Button>
      </Modal.Footer>
    </Modal>
  );
}
